import {MutableRefObject, Ref, RefObject, useMemo, useRef} from 'react';

export function useComposedRef<TInstance>(externalRef: Ref<TInstance> | undefined) {
    const internalRef = useRef<TInstance | null>(null);

    return useMemo(
        (): RefObject<TInstance> => ({
            set current(value) {
                internalRef.current = value;
                if (typeof externalRef === 'function') {
                    externalRef(value);
                } else if (externalRef) {
                    (externalRef as MutableRefObject<TInstance | null>).current = value;
                }
            },
            get current() {
                return internalRef.current;
            },
        }),
        [externalRef]
    );
}
